import Tender from './Tender';

const PaymentMethod = (props) => {
  const { order, settings } = props;
  if (!order.tenders) {
    return null;
  }
  const successTenders = order.tenders.filter(
    (tender) => tender.chargeStatus === 'Success'
  );
  if (successTenders.length === 0) {
    return null;
  }
  if (successTenders.length === 1) {
    return (
      <span className="c7-account__credit-card">
        <strong>Payment method</strong>
        {successTenders.map((tender) => (
          <Tender
            key={tender.id}
            tender={tender}
            multiple={false}
            settings={settings}
          />
        ))}
      </span>
    );
  }
  return (
    <span className="c7-account__credit-card">
      <strong>Payment method</strong>
      {successTenders.map((tender) => (
        <Tender key={tender.id} tender={tender} multiple settings={settings} />
      ))}
    </span>
  );
};

export default PaymentMethod;
